import { connect } from 'react-redux';

import { IAddComplaintOptions } from '../../../api/complaint';
import { addComplaint } from '../../../store/complaint/add_complaint';
import { ComplaintItem, IComplaintItemProps } from './index';

import type { DispatchReduxAction, IState } from '../../../store';

type TStoreFields = Pick<IComplaintItemProps, 'agent' | 'offer'>;
type TActions = Pick<IComplaintItemProps, 'addComplaint'>;
type TOwnProps = Pick<IComplaintItemProps, 'complaint' | 'index' | 'isSelected' | 'onSelect'>;

export function mapStateToProps(state: IState): TStoreFields {
  return {
    agent: state.offerData.agent,
    offer: state.offerData.offer,
  };
}

/* istanbul ignore next */
function mapDispathToProps(dispatch: DispatchReduxAction): TActions {
  return {
    addComplaint: (options: IAddComplaintOptions) => dispatch(addComplaint(options)),
  };
}

export const ComplaintItemContainer = connect<TStoreFields, TActions, TOwnProps>(
  mapStateToProps,
  mapDispathToProps,
)(ComplaintItem);
